import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'

import { REDUX_ACTION_PREFIX } from 'modules/redux/constants'
import logUtil from 'utils/log'

import {
  PRODUCTS_DOMAIN,
  PRODUCTS_KEY,
  PRODUCTS_PATH
} from 'modules/product/redux/constants'

import saveReduxAction from 'modules/redux/actions/save'
import joinPathsStrUtil from 'utils/string/join-paths'
import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'

const API_ENDPOINT = 'pssurveys/quickrating'

export default function updateProductRatingStatusAction ({
  productId,
  rating

}) {
  return (dispatch, getState) => {
    const logPrefix = `productId=${productId}`
    logUtil('updateProductRatingStatusAction').debug(`${logPrefix} [start] rating=`, rating)

    const existingData = getHasSampledProductDataSelector(productId)(getState())

    logUtil('updateProductRatingStatusAction').debug(`${logPrefix} [start] existingData=`, existingData)

    const value = {
      ...existingData,
      pssAnswer: rating,
      hasSampled: true
    }

    const questionId = existingData?.questionId
    if (!questionId) {
      logUtil('updateProductRatingStatusAction').debug(`${logPrefix} [noop] no questionId`)
      return
    }

    const answer = rating

    const payload = {
      question_id: questionId,
      answer
    }

    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.UPDATE,
      PRODUCTS_DOMAIN,
      PRODUCTS_KEY.HAS_SAMPLED_BY_ID
    )

    const path = joinPathsStrUtil(PRODUCTS_PATH[PRODUCTS_KEY.HAS_SAMPLED_BY_ID], productId)

    const endpoint = `${API_ENDPOINT}`

    return dispatch(
      saveReduxAction({
        action,
        method: 'PUT',
        path,
        endpoint,
        data: payload,
        resDataToSet: value,
        isImmediateUpdate: true
      })
    )
  }
}
